import type { Vec3 } from '../../geo/types';
import { ANCHOR, centreAnchorCode, facingFootCode, shareFootCode } from '../../render/anchorCode';
import type { ExaggerationStyle } from './meshBuilder';

/** The builder's per-vertex channels: their growth and the exaggeration code a style writes. */

export function grown(
  array: Float32Array,
  vertices: number,
  perVertex: number
): Float32Array<ArrayBuffer> {
  const next = new Float32Array(vertices * perVertex);
  next.set(array);
  return next;
}

export function exaggerationCode(exaggeration: ExaggerationStyle, world: Vec3): number {
  if (exaggeration.share !== undefined) {
    if (exaggeration.anchor || exaggeration.outward) {
      throw new RangeError('An exaggeration code carries a share or a centre or a facing, not two');
    }
    return shareFootCode(exaggeration.share);
  }
  if (exaggeration.anchor) return centreAnchorCode(exaggeration.anchor);
  return exaggeration.outward ? facingFootCode(exaggeration.outward(world)) : ANCHOR.foot;
}

/** Foot, share and centre anchors are constant across a face; a facing callback remains per vertex. */
export function fixedExaggerationCode(style: ExaggerationStyle | undefined): number | undefined {
  return style && (!style.outward || style.anchor) ? exaggerationCode(style, [0, 0, 0]) : undefined;
}
